import { RedoOutlined, SearchOutlined } from "@ant-design/icons"
import { Button, Card, ConfigProvider, Form, Input, Select, Space } from "antd"
import type React from "react"
import { memo, useEffect } from "react"

interface SettingsFilterFormProps {
  groups: string[]
  onSearch: (values: { search?: string; group?: string }) => void
  loading?: boolean
  initialValues?: { search?: string; group?: string }
}

export const SettingsFilterForm: React.FC<SettingsFilterFormProps> = memo(
  ({ groups, onSearch, loading = false, initialValues }) => {
    const [form] = Form.useForm()

    useEffect(() => {
      if (initialValues) {
        form.setFieldsValue(initialValues)
      }
    }, [initialValues, form])

    const handleSearch = () => {
      form.validateFields().then((values) => {
        onSearch(values)
      })
    }

    const handleReset = () => {
      form.resetFields()
      onSearch({
        search: "",
        group: undefined,
      })
    }

    const groupOptions = [
      { label: "Tất cả các nhóm (All)", value: "all" },
      ...groups.map((g) => ({
        label: `Nhóm "${g}"`,
        value: g,
      })),
    ]

    return (
      <ConfigProvider
        theme={{
          components: {
            Form: {
              itemMarginBottom: 0,
            },
          },
        }}
      >
        <Card className="shadow-xs">
          <Form
            form={form}
            layout="inline"
            className="flex flex-wrap items-center gap-3"
            initialValues={{
              search: "",
              group: "all",
            }}
          >
            <Form.Item name="group" label="Nhóm cấu hình" className="min-w-[200px]">
              <Select
                placeholder="Chọn nhóm"
                options={groupOptions}
                allowClear
                onChange={() => handleSearch()}
              />
            </Form.Item>

            <Form.Item name="search" label="Tên cấu hình" className="min-w-[250px]">
              <Input
                placeholder="Tìm theo tên setting..."
                allowClear
                onPressEnter={handleSearch}
              />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  onClick={handleSearch}
                  loading={loading}
                >
                  Tìm kiếm
                </Button>
                <Button icon={<RedoOutlined />} onClick={handleReset}>
                  Làm mới
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </ConfigProvider>
    )
  }
)

SettingsFilterForm.displayName = "SettingsFilterForm"
